import React, { useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';
import { ListingListItemSkeleton } from './ListItemSkeleton';

export const ListingListItem = ({ listing, loading }) => {
  const wrapperRef = useRef(null);

  useLayoutEffect(() => {
    if (!wrapperRef.current) {
      return;
    }

    const script = document.createElement('script');
    script.src = listing.scriptUrl;
    script.async = true;

    wrapperRef.current.appendChild(script);

    return () => {
      wrapperRef.current.removeChild(script);
    }
  }, []);

  return (
    <>
      <div
        ref={wrapperRef}
        className={classNames("listing-item", {"listing-item-loading": loading})}
      />
      <ListingListItemSkeleton loading={loading} />
    </>
  );
}